<template>
  <div>
    <h3>Saved Queries:</h3>
    <ul>
      <li v-for="(item, index) in savedQueries" :key="index" class="query-item">
        {{ item.date }}
        <span v-if="item.preset === 'search'">Search: {{ item.searchItem }}</span>
        <span v-else-if="item.preset === 'report'">Report on: {{ item.subject }}</span>
        <div class="query-actions">
        <button class="mx-2" @click="$emit('edit-query', index)">Edit</button>
        <button class="mx-2" @click="$emit('delete-query', index)">Delete</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedQueries: {
      type: Array,
      default: () => [],
    },
  },
};
</script>


<style>
ul {
  list-style-type: none;
  padding: 0;
}

.query-item {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.query-date {
  font-weight: bold;
}

.query-actions {
  margin-top: 10px;
}

.btn-edit, .btn-delete {
  cursor: pointer;
  padding: 5px 10px;
  margin-right: 5px;
  border: none;
  border-radius: 3px;
  background-color: #007bff;
  color: white;
}

.btn-delete {
  background-color: #dc3545;
}

/* Add any additional styling as needed */
</style>
